import axios from "axios";
import { initDeviceId } from "../device";
import { v4 as uuidv4 } from "uuid";
import { ARGUS_APM } from "../../apm";

export async function loginWithPhone(payload, clientId) {
  const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/login/phone`;
  return login(endpoint, clientId, payload);
}

export async function loginWithApple(payload, clientId) {
  const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/login/apple`;
  return login(endpoint, clientId, payload);
}

export async function loginWithFacebook(payload, clientId) {
  const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/login/facebook`;
  return login(endpoint, clientId, payload);
}

export async function loginWithEmail(payload, clientId) {
  const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/login/email`;
  return login(endpoint, clientId, payload);
}

async function login(endpoint, clientId, payload) {
  payload.device_id = await initDeviceId().catch((ex) => {
    console.log(ex);
    let e = Error("deviceId is empty. " + ex?.message);
    e.causedBy = ex;
    if (ARGUS_APM) {
      ARGUS_APM.captureError(e);
    }
  });
  if (!(payload.device_id?.length > 0)) {
    if (ARGUS_APM) {
      ARGUS_APM.captureError(Error("deviceId is empty. fallback to uuid"));
    }
    payload.device_id = uuidv4();
  }
  return axios
    .post(endpoint, payload, {
      headers: {
        "x-idp-client-id": clientId,
      },
    })
    .then((res) => res?.data);
}
